<!-- Featured Event Hero Banner -->
<div class="hero-banner" *ngIf="featuredEvents.length > 0">
  <div class="hero-image">
    <img
      [src]="getFeaturedImageUrl()"
      [alt]="featuredEvents[currentFeaturedIndex]?.name"
    />
    <div class="hero-overlay"></div>
  </div>
  <div class="hero-content">
    <span class="hero-badge">Featured Event</span>
    <h2 class="hero-title">{{ featuredEvents[currentFeaturedIndex]?.name }}</h2>
    <div class="hero-meta">
      <span class="hero-meta-item">
        <i nz-icon nzType="calendar" aria-hidden="true"></i>
        {{ featuredEvents[currentFeaturedIndex]?.date | date: 'mediumDate' }}
      </span>
      <span
        class="hero-meta-item"
        *ngIf="featuredEvents[currentFeaturedIndex]?.location?.description"
      >
        <i nz-icon nzType="environment" aria-hidden="true"></i>
        {{ featuredEvents[currentFeaturedIndex]?.location?.description }}
      </span>
    </div>
    <a
      class="hero-cta"
      [routerLink]="[
        '/tickets',
        featuredEvents[currentFeaturedIndex]?.slug,
        featuredEvents[currentFeaturedIndex]?.uid,
        featuredEvents[currentFeaturedIndex]?.eventType?.uid
      ]"
    >
      View Event
    </a>
  </div>
  <!-- Dots navigation -->
  <div class="hero-dots" *ngIf="featuredEvents.length > 1">
    <button
      *ngFor="let event of featuredEvents; let i = index"
      type="button"
      class="hero-dot"
      [class.active]="i === currentFeaturedIndex"
      (click)="goToFeatured(i)"
      [attr.aria-label]="'Go to event ' + (i + 1)"
    ></button>
  </div>
</div>

<div class="page-container">
  <!-- Welcome Header -->
  <div class="welcome-banner">
    <div>
      <h1 class="welcome-title">Welcome back!</h1>
      <p class="welcome-sub" *ngIf="userEmail">{{ userEmail }}</p>
    </div>
    <a class="buy-tickets-btn" routerLink="/events">
      <i nz-icon nzType="calendar" aria-hidden="true"></i>
      Browse Events
    </a>
  </div>

  <nz-spin [nzSpinning]="loading">
    <!-- Stats Grid -->
    <div class="stats-grid" *ngIf="dashboardData">
      <div class="stat-card">
        <div class="stat-icon blue">
          <i nz-icon nzType="shopping-cart" aria-hidden="true"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value tabular-nums">{{
            dashboardData.orderStats.totalOrders
          }}</span>
          <span class="stat-label">Total Orders</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon purple">
          <i nz-icon nzType="environment" aria-hidden="true"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value tabular-nums">{{
            dashboardData.totalEventsAttended
          }}</span>
          <span class="stat-label">Events Attended</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon green">
          <i nz-icon nzType="dollar" aria-hidden="true"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value tabular-nums">{{
            formatCurrency(
              dashboardData.orderStats.totalSpend,
              dashboardData.orderStats.preferredCurrency
            )
          }}</span>
          <span class="stat-label">Total Spend</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon orange">
          <i nz-icon nzType="calendar" aria-hidden="true"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value tabular-nums">{{
            dashboardData.upcomingEvents
          }}</span>
          <span class="stat-label">Upcoming Events</span>
        </div>
      </div>
    </div>

    <!-- Main grid: content + sidebar -->
    <div class="dashboard-grid">
      <!-- Main column -->
      <div class="dashboard-main">
        <!-- Quick Actions -->
        <div class="section-block">
          <h2 class="section-title">Quick Actions</h2>
          <div class="quick-actions">
            <a routerLink="/orders" class="action-card">
              <div class="action-icon blue">
                <i nz-icon nzType="shopping" aria-hidden="true"></i>
              </div>
              <span class="action-label">My Orders</span>
            </a>
            <a routerLink="/tickets" class="action-card">
              <div class="action-icon purple">
                <i nz-icon nzType="qrcode" aria-hidden="true"></i>
              </div>
              <span class="action-label">My Tickets</span>
            </a>
            <!-- <a routerLink="/check-ins" class="action-card">
              <div class="action-icon green"><i nz-icon nzType="check-square" aria-hidden="true"></i></div>
              <span class="action-label">Check-ins</span>
            </a> -->
            <a routerLink="/events" class="action-card">
              <div class="action-icon pink">
                <i nz-icon nzType="calendar" aria-hidden="true"></i>
              </div>
              <span class="action-label">Events</span>
            </a>
            <a
              [href]="organiserSignupUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="action-card"
            >
              <div class="action-icon green">
                <i nz-icon nzType="rocket" aria-hidden="true"></i>
              </div>
              <span class="action-label">Become an Organiser</span>
            </a>
            <a
              [href]="organiserLoginUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="action-card"
            >
              <div class="action-icon orange">
                <i nz-icon nzType="shop" aria-hidden="true"></i>
              </div>
              <span class="action-label">Organiser Login</span>
            </a>
          </div>
        </div>

        <!-- Coming Soon Events -->
        <div class="section-block" *ngIf="comingSoonEvents.length > 0">
          <h2 class="section-title">Coming Soon</h2>
          <hypenation-tickets-events-list
            [events]="comingSoonEvents"
            [loading]="false"
            [showFiltering]="false"
            [showPagination]="false"
            [title]="''"
          ></hypenation-tickets-events-list>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="dashboard-sidebar">
        <!-- Order Status -->
        <div class="sidebar-card" *ngIf="dashboardData">
          <h3 class="sidebar-card-title">Order Status</h3>
          <div class="status-list">
            <div class="status-row">
              <div class="status-dot green"></div>
              <span class="status-label">Completed</span>
              <span class="status-count tabular-nums">{{
                dashboardData.orderStats.completedOrders
              }}</span>
            </div>
            <div class="status-row">
              <div class="status-dot yellow"></div>
              <span class="status-label">Pending</span>
              <span class="status-count tabular-nums">{{
                dashboardData.orderStats.pendingOrders
              }}</span>
            </div>
            <div class="status-row">
              <div class="status-dot red"></div>
              <span class="status-label">Cancelled</span>
              <span class="status-count tabular-nums">{{
                dashboardData.orderStats.cancelledOrders
              }}</span>
            </div>
          </div>
        </div>

        <!-- Favourite Organisers -->
        <div class="sidebar-card">
          <h3 class="sidebar-card-title">Top Organisers</h3>
          <div *ngIf="favouriteOrganisers.length > 0; else noOrganisers">
            <a
              *ngFor="let organiser of favouriteOrganisers"
              class="organiser-row"
              [routerLink]="[
                '/organisers',
                organiser.organiserUid || organiser.uid
              ]"
            >
              <div class="organiser-avatar">
                {{
                  (organiser.organiserName || organiser.name || 'O').charAt(0)
                }}
              </div>
              <div class="organiser-info">
                <p class="organiser-name">
                  {{
                    organiser.organiserName ||
                      organiser.name ||
                      'Unknown Organiser'
                  }}
                </p>
                <p class="organiser-meta" *ngIf="organiser.ticketCount">
                  {{ organiser.ticketCount }} tickets purchased
                </p>
              </div>
            </a>
          </div>
          <ng-template #noOrganisers>
            <p class="empty-text">
              No organisers yet.
              <a routerLink="/organisers" class="discover-link"
                >Discover organisers</a
              >
            </p>
          </ng-template>
        </div>

        <!-- Organiser Portal -->
        <div class="sidebar-card">
          <h3 class="sidebar-card-title">Organiser Portal</h3>
          <p class="organiser-portal-desc">
            Host your own events on Hypenation.
          </p>
          <div class="organiser-portal-links">
            <a
              [href]="organiserSignupUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="organiser-portal-link"
            >
              <i nz-icon nzType="rocket" aria-hidden="true"></i>
              Become an Organiser
            </a>
            <a
              [href]="organiserLoginUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="organiser-portal-link"
            >
              <i nz-icon nzType="login" aria-hidden="true"></i>
              Login to Organiser Portal
            </a>
          </div>
        </div>
      </div>
    </div></nz-spin
  >
</div>
